import { RouteParameters } from "./route-parameters";

const ADMIN_ROUTING = {
  REPORTS: {
    FLEET: {
      COUNTERS: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin/reports/fleet/counters`,
      PRE_FLIGHTS: {
        CONFIGURE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin/reports/pre-flights/configure`,
        ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin/reports/pre-flights`,
        VIEW: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin/reports/pre-flights/view`,
      },
      ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin/reports/fleet`,
      W_AND_B: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin/reports/fleet/w-and-b`,
    },
    ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin/reports`,
  },
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/admin`,
} as const;

export { ADMIN_ROUTING };
